import { render, staticRenderFns } from "./fr.svg?vue&type=template&id=1c9cf112&"
var script = {}


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports